import { Label } from '@cian/ui-kit';
import { IconComfortArmchair16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';
import { useSelector } from 'react-redux';
import { selectOffer } from 'shared/selectors/offerData/selectOffer';

import { useApplicationContext } from '../ApplicationContext';

export const IsSoldFurnishedLabelContainer: React.FC = () => {
  const { isSoldFurnished } = useSelector(selectOffer);

  const { config } = useApplicationContext();
  const text = config.get<string>('labels.isSoldFurnished') || 'С мебелью';

  if (!isSoldFurnished) {
    return null;
  }

  return (
    <Label
      color="accent-warning-primary"
      background="surface-warning-default"
      icon={<IconComfortArmchair16 color="icon-warning-default" />}
    >
      {text}
    </Label>
  );
};
